import { createStyles } from "@material-ui/core";
import theme from "../../theme";

export default createStyles({

  root: {
    backgroundImage: `url("")`,
  },

  banner: { },

  bannerHeading: { },

  bannerDescription: { },

});

